<template>
  <div class="page__subtitle">
    Выберите ваш научный уровень (категорию)
  </div>
  <div class="btn__container">
<!--    <div :class="level.schoolchild ? 'btn__level click' : 'btn__level'" @click="clickLevelBtn('schoolchild')">-->
<!--        <span class="btn__level_text">-->
<!--          ШКОЛЬНИК-->
<!--        </span>-->
<!--    </div>-->
<!--    <div :class="level.student ? 'btn__level click' : 'btn__level'" @click="clickLevelBtn('student')">-->
<!--        <span class="btn__level_text">-->
<!--          СТУДЕНТ-->
<!--        </span>-->
<!--    </div>-->
    <div :class="level.postgraduate ? 'btn__level click' : 'btn__level'" @click="clickLevelBtn('postgraduate')">
        <span class="btn__level_text">
          АСПИРАНТ
        </span>
    </div>
    <div :class="level.science ? 'btn__level click' : 'btn__level'" @click="clickLevelBtn('science')">
        <span class="btn__level_text">
          МОЛОДОЙ УЧЕНЫЙ
        </span>
    </div>
    <div class="alert__container" v-if="error">
      <v-alert
          class="error_alert"
          :value="true"
          outline
          :icon="false"
          color="#8f0808"
          variant="outlined"
      >
        Выберите свой научный уровень
      </v-alert>
    </div>
    <v-btn
        class="btn__next"
        elevation="0"
        :loading="loading"
        @click="goToNextStage"
    >
        <span class="btn__next_text">
          ДАЛЕЕ
        </span>
    </v-btn>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapGetters } from "vuex"

export default defineComponent({
  name: "UpdateLevel",
  computed: {
    names () {
      return names
    },
    pa_names () {
      return pa_names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
    })
  },
  data () {
    return {
      level: {
        schoolchild: false,
        student: false,
        postgraduate: false,
        science: false
      },
      error: false,
      loading: false
    }
  },
  methods: {
    clickLevelBtn (level) {
      if (!this.level[level]) {
        for (const key in this.level) {
          if (key !== level) {
            this.level[key] = false
          }
        }
        this.level[level] = true
        this.error = false
      }
    },
    goToNextStage () {
      this.loading = true
      if (this.level.schoolchild) {
        this.endRedirect("schoolchild")
      } else if (this.level.student) {
        this.endRedirect("student")
      } else if (this.level.postgraduate) {
        this.endRedirect("postgraduate")
      } else if (this.level.science) {
        this.endRedirect("science")
      } else {
        this.error = true
        this.loading = false
      }
    },
    endRedirect (type) {
      this.$router.push({ name: names.UPDATE_INDIVIDUAL.PAGE, query: { type: type } })
      this.loading = false
      // if (this.getUserStatus.member && !this.getUserStatus.is_not_valid) {
      //   this.$router.push({ name: names.UPDATE_INDIVIDUAL.PAGE, query: { type: type } })
      //   this.loading = false
      // } else {
      //   this.$router.push({ name: names.UPDATE_MAIN.PAGE, query: { type: type } })
      //   this.loading = false
      // }
    }
  },
  created () {
    if (!this.getUserStatus.can_update || !this.getUserStatus.is_expired) {
      this.$router.push({ name: pa_names.MAIN })
    }
  }
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.btn__container {
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: 500px;
}

.btn__level {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 40px;
  width: 100%;
  height: 80px;
  border: 2px solid #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: #3254B9;

    .btn__level_text {
      color: #FFFFFF;
    }
  }

  &.click {
    background-color: #3254B9;

    .btn__level_text {
      color: #FFFFFF;
    }
  }
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 50px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.btn__level_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #3254B9;
}

.alert__container {
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
  width: 100%;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .btn__level {
    height: 70px;
    margin-bottom: 30px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .btn__container {
    width: 400px;
  }

  .btn__level {
    margin-bottom: 20px;
    height: 55px;
  }

  .btn__level_text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;

    &.back {
      margin-right: 0;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .btn__container {
    width: 270px;
  }
}
</style>
